import { Dispatch, SetStateAction } from 'react';
import { useFormContext } from 'react-hook-form';

import { Button, Text } from '#atoms';
import { PrevHeaderBarWithTitleTemplate } from '#templates';

import { ButtonContainer, Container, Hyphen, InputContainer } from './styles';

export function BillingRegRRNPage({
  setStep
}: {
  setStep: Dispatch<SetStateAction<string>>;
}) {
  const methods = useFormContext();

  const onChangeSlicer = (
    targetValue: string,
    registerName: string,
    max: number
  ) => {
    if (targetValue.length > max) {
      return methods.setValue(registerName, targetValue.slice(0, max));
    } else {
      return methods.setValue(registerName, targetValue);
    }
  };

  return (
    <PrevHeaderBarWithTitleTemplate prevRoute={'/profile'} title="수입관리">
      <Container>
        <div>
          <Text textStyle="t1">정산을 위해</Text>
          <Text textStyle="t1">주민등록번호를 입력해주세요</Text>
        </div>
        <InputContainer>
          <input
            type="number"
            className="w-full px-16 py-15 rounded-8 bg-[#24222A] text-center"
            {...methods.register('residentNumberFirst', {
              required: true,
              pattern: /^\d{6}$/,
              onChange: e =>
                onChangeSlicer(e.target.value, 'residentNumberFirst', 6)
            })}
            placeholder="-"
          />
          <Hyphen>
            <hr />
          </Hyphen>
          <input
            type="number"
            className="w-full px-16 py-15 rounded-8 bg-[#24222A] text-center"
            {...methods.register('residentNumberLast', {
              required: true,
              pattern: /^\d{7}$/,
              onChange: e =>
                onChangeSlicer(e.target.value, 'residentNumberLast', 7)
            })}
            placeholder="-"
          />
        </InputContainer>
      </Container>
      <ButtonContainer>
        <Button
          type="button"
          disabled={!methods.formState.isValid}
          onClick={() => setStep('accountInfo')}
        >
          다음
        </Button>
      </ButtonContainer>
    </PrevHeaderBarWithTitleTemplate>
  );
}
